/**
 * Actions for connection header component
 */
import { keyBy } from "lodash";
import * as actionTypes from "./actionTypes";

/**
 * Action is called to save connection header details
 * @param {*} payload Api req parameters
 */
export function saveConnectionHeader(payload) {
  return { type: actionTypes.SAVE_CONNECTION_HEADER, payload };
}

/**
 * Action is called to save connection header details success
 * @param {*} payload Api res parameters
 */
export function saveConnectionHeaderSuccess(payload) {
  // console.log('savepayload..', payload)
  return { type: actionTypes.SAVE_CONNECTION_HEADER_SUCCESS, payload };
}

/**
 * Action is called to update connection header details
 * @param {*} payload Api req parameters
 */

export function updateConnectionHeader(payload) {
  return { type: actionTypes.UPDATE_CONNECTION_HEADER, payload };
}
/**
 * Action is called to update connection header details success
 * @param {*} payload Api res parameters
 */
export function updateConnectionHeaderSuccess(payload) {
  return { type: actionTypes.UPDATE_CONNECTION_HEADER_SUCCESS, payload };
}
/**
 * Action is called to fetch all connection headers
 * @param {*} payload Api req parameters
 */
export function fetchConnectionHeaders(payload) {
  return { type: actionTypes.FETCH_CONNECTION_HEADERS, payload };
}
/**
 * Action is called to fetch all connection headers success
 * @param {*} payload Api res parameters
 */
export function fetchConnectionHeadersSuccess(payload) {
  const byId = keyBy(payload, (post) => post.connectionheaderUid);
  return {
    type: actionTypes.FETCH_CONNECTION_HEADERS_SUCCESS,
    payload: { byId },
  };
}
/**
 * Action is called to delete connection header
 * @param {*} payload Api req parameters
 */
export function deleteConnectionHeader(payload) {
  return { type: actionTypes.DELETE_CONNECTION_HEADER, payload };
}
/**
 * Action is called to delete connection header success
 * @param {*} payload Api res parameters
 */
export function deleteConnectionHeaderSuccess(payload) {
  return { type: actionTypes.DELETE_CONNECTION_HEADER_SUCCESS, payload };
}
